import { Button, Space } from "@pankod/refine-antd";
import { useEffect } from "react";
import { BaseKey, useUpdate } from "@pankod/refine-core";
import { ACTIVE_PAY_RATE_API, DEACTIVE_PAY_RATE_API } from "api/baseApi";
import { openNotification } from "utils";
import { StandardPayRatesProps } from "./interface";
import { EStatusNotification, MSG_NOTIFICATION } from "constants/constant";

const PayRateActive = (props: StandardPayRatesProps) => {
  const { setIsModalVisible, payRate, page, handleChange, refetch } = props;
  const { mutate, data: activeData, isLoading: isLoadingActive } = useUpdate();

  const handleChangeActive = () => {
    if (payRate?.isActive === true) {
      mutate({
        resource: DEACTIVE_PAY_RATE_API,
        id: payRate?.id,
        values: {
          name: payRate,
        },
      });
    } else {
      mutate({
        resource: ACTIVE_PAY_RATE_API,
        id: payRate?.id as BaseKey,
        values: {
          name: payRate,
        },
      });
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (activeData?.data.status == 200) {
      setIsModalVisible(false);
      handleChange(page);
      openNotification(MSG_NOTIFICATION.SUCCESSFUL, activeData?.data?.message, EStatusNotification.SUCCESS);
      if (refetch) {
        refetch();
      }
    }
  }, [activeData, setIsModalVisible]);

  return (
    <Space
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "baseline",
      }}
    >
      <div>
        You are about to change the Active Status of this{" "}
        <strong>Pay/Bill Rates</strong>. Please select <strong>Change</strong>{" "}
        to continue or <strong>Cancel</strong> to go back
      </div>
      <Space style={{ marginTop: 10 }}>
        <Button
          onClick={handleChangeActive}
          className="btn-create"
          style={{ marginRight: "10px", backgroundColor: "#" }}
        >
          Change
        </Button>
        <Button onClick={handleCancel}>Cancel </Button>
      </Space>
    </Space>
  );
};

export default PayRateActive;
